import React from 'react';
import { TwitterIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-50 pt-20 pb-10 border-t border-slate-200" data-id="element-69">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-70">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-71">
          <div className="col-span-1 md:col-span-1" data-id="element-72">
            <div className="flex items-center space-x-2 mb-6" data-id="element-73">
              <div className="w-6 h-6 overflow-hidden flex items-center justify-center" data-id="element-74">
                <img src="https://cdn.magicpatterns.com/uploads/hRxQvVCJnxZUvLiFBQfhZy/Kinase_logo_—_transparent,_cropped.png" alt="Kinase Icon" className="h-full w-auto object-cover object-left" style={{
                filter: 'brightness(0) saturate(100%) invert(55%) sepia(60%) saturate(500%) hue-rotate(130deg) brightness(95%) contrast(90%)'
              }} data-id="element-75" />
              </div>
              <div className="flex items-baseline gap-2" data-id="element-76">
                <span className="text-xl font-bold text-slate-900 tracking-tight leading-none" data-id="element-77">
                  Kinase
                </span>
                <span className="text-[10px] text-slate-400 font-normal italic tracking-wide" data-id="element-78">
                  (ky · nase)
                </span>
              </div>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed mb-6" data-id="element-79">
              Sales intelligence infrastructure. Automatically extract
              qualification data and sync to HubSpot.
            </p>
            <div className="flex space-x-4" data-id="element-80">
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-81">
                <TwitterIcon className="w-5 h-5" data-id="element-82" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-83">
                <LinkedinIcon className="w-5 h-5" data-id="element-84" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-85">
                <GithubIcon className="w-5 h-5" data-id="element-86" />
              </a>
            </div>
          </div>

          <div data-id="element-87">
            <h4 className="text-slate-900 font-medium mb-4" data-id="element-88">Product</h4>
            <ul className="space-y-3" data-id="element-89">
              <li data-id="element-90">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-91">
                  Features
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-93">
                  Integrations
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-95">
                  Pricing
                </a>
              </li>
              <li data-id="element-96">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-97">
                  Changelog
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-98">
            <h4 className="text-slate-900 font-medium mb-4" data-id="element-99">Company</h4>
            <ul className="space-y-3" data-id="element-100">
              <li data-id="element-101">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-102">
                  About
                </a>
              </li>
              <li data-id="element-103">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-104">
                  Blog
                </a>
              </li>
              <li data-id="element-105">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-106">
                  Careers
                </a>
              </li>
              <li data-id="element-107">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-108">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-109">
            <h4 className="text-slate-900 font-medium mb-4" data-id="element-110">Stay updated</h4>
            <p className="text-slate-600 text-sm mb-4" data-id="element-111">
              Get the latest updates on product features and releases.
            </p>
            <form className="flex" data-id="element-112">
              <input type="email" placeholder="Enter your email" className="bg-white border border-slate-300 rounded-lg px-4 py-2.5 text-sm text-slate-900 placeholder-slate-400 flex-1 focus:outline-none focus:ring-2 focus:ring-teal-500/50 shadow-sm" data-id="element-113" />
              <button className="bg-teal-500 hover:bg-teal-400 text-white px-4 py-2.5 rounded-lg text-sm font-medium ml-2 transition-colors shadow-sm shadow-teal-500/20" data-id="element-114">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between" data-id="element-115">
          <p className="text-slate-500 text-sm mb-4 md:mb-0" data-id="element-116">
            © {new Date().getFullYear()} Kinase AI Inc. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-117">
            <a href="#" className="text-slate-500 hover:text-slate-900 text-sm transition-colors" data-id="element-118">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-slate-900 text-sm transition-colors" data-id="element-119">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}